import styled from "styled-components";
export const Styles = styled.div`
  #leaderBoardsSection {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    border-bottom: none !important;
    --bs-nav-tabs-border-radius: 10px !important;
  }
  #leaderBoardsSection .course-swiper {
    width: 55%;
  }
  #leaderBoardsSection .course-swiper .swiper-wrapper {
    padding-bottom: 5px;
  }
  #leaderBoardsSection .course-swiper.swiper-with-pages .swiper-wrapper {
    justify-content: center !important;
  }
  #leaderBoardsSection .course-swiper .swiper-wrapper .swiper-slide {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  #leaderBoardsSection .course-swiper .swiper-button-lock {
    display: none;
  }
  .course-swiper .nav-tabs {
    border: none !important;
  }
  #leaderBoardsSection .course-swiper .nav-item {
    text-align: center;
    color: var(--dark-purple);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  #leaderBoardsSection .course-swiper .nav-item button {
    border-radius: 10px !important;
    width: 300px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  #leaderBoardsSection .course-swiper .nav-item .nav-link {
    color: var(--dark-purple) !important;
    background-color: #fff;
    border: 1px solid var(--dark-purple);
  }
  #leaderBoardsSection .course-swiper .nav-item .nav-link.active,
  #leaderBoardsSection .course-swiper .nav-item .nav-link:hover {
    color: #fff !important;
    background-color: var(--dark-purple);
    border: 1px solid var(--dark-purple);
  }
  #leaderBoardsSection .course-swiper .title {
    max-width: 150px;
    font-weight: bold;
  }
  #leaderBoardsSection .leaderboards-data {
    display: flex;
    align-items: center;
    justify-content: center;
    animation-name: slidein;
    animation-duration: 1s;
    margin-top: -25px;
  }
  @keyframes slidein {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }
  #leaderBoardsSection .leaderboards-data .leaderboards-data-item {
    padding-top: 80px;
    position: relative;
    z-index: 2;
    text-align: center;
    font-size: 15px;
    width: 280px;
    height: 350px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  #leaderBoardsSection .leaderboards-data .leaderboards-data-item:first-child {
    margin-inline-end: -95px;
    margin-top: 90px;
    z-index: 1;
  }
  #leaderBoardsSection .leaderboards-data .leaderboards-data-item:last-child {
    margin-inline-start: -95px;
    margin-top: 90px;
    z-index: 1;
  }
  #leaderBoardsSection
    .leaderboards-data
    .leaderboards-data-item
    .item-ranking {
    position: absolute;
    top: 10px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 25px;
  }
  #leaderBoardsSection .leaderboards-data .leaderboards-data-item .item-img {
    position: relative;
    border: 10px solid var(--dark-purple);
    border-radius: 50%;
    width: 220px;
    height: 220px;
    box-shadow: 0px 0px 20px var(--dark-purple);
    margin-bottom: 20px;
    background-color: var(--dark-purple);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  #leaderBoardsSection
    .leaderboards-data
    .leaderboards-data-item.first
    .item-img {
    width: 260px;
    height: 260px;
  }
  #leaderBoardsSection
    .leaderboards-data
    .leaderboards-data-item
    .item-img.first-item {
    box-shadow: 0px 0px 10px #fff;
  }
  #leaderBoardsSection
    .leaderboards-data
    .leaderboards-data-item
    .item-img
    img {
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
  }
  #leaderBoardsSection
    .leaderboards-data
    .leaderboards-data-item
    .item-img
    img.user-avatar {
    max-width: 50%;
    max-height: 50%;
    object-fit: cover;
  }
  #leaderBoardsSection .leaderboards-data .leaderboards-data-item .item-crown {
    position: absolute;
    top: -40px;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 50px;
  }
  #leaderBoardsSection
    .leaderboards-data
    .leaderboards-data-item
    .item-crown
    img {
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
  }
  #leaderBoardsSection .leaderboards-data .leaderboards-data-item .item-name {
    font-size: 20px;
    width: 220px;
  }
  .leaderboard-container {
    position: relative;
  }
  .leaderboard-container .btn-next,
  .leaderboard-container .btn-prev {
    z-index: 20;
    background: transparent;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: var(--light-purple);
    cursor: pointer;
    transition: 0.3s;
    color: var(--dark-purple);
    border: 1px solid var(--light-purple);
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
  .leaderboard-container .btn-next {
    right: 20%;
    left: auto;
    transform: rotate(180deg);
  }
  .leaderboard-container .btn-next.btn-next-en {
    left: 20%;
    right: auto;
    transform: rotate(0);
  }
  .leaderboard-container .btn-prev {
    left: 20%;
    right: auto;
    transform: rotate(180deg);
  }
  .leaderboard-container .btn-prev-en {
    right: 20%;
    left: auto;
    transform: rotate(0);
  }
  @media (max-width: 1400px) {
    #leaderBoardsSection .course-swiper {
      width: 60%;
      /* padding-inline: 25px; */
    }
  }
  @media (max-width: 1200px) {
    #leaderBoardsSection .course-swiper {
      width: 80%;
    }
    .leaderboard-container .btn-next {
      right: 10%;
      left: auto;
    }
    .leaderboard-container .btn-next.btn-next-en {
      left: 10%;
      right: auto;
    }
    .leaderboard-container .btn-prev {
      left: 10%;
      right: auto;
    }
    .leaderboard-container .btn-prev-en {
      right: 10%;
      left: auto;
    }
  }
  @media (max-width: 992px) {
    #leaderBoardsSection .course-swiper {
      width: 100%;
    }
    .leaderboard-container .btn-next {
      right: 0;
      left: auto;
    }
    .leaderboard-container .btn-next.btn-next-en {
      left: 0;
      right: auto;
    }
    .leaderboard-container .btn-prev {
      left: 0;
      right: auto;
    }
    .leaderboard-container .btn-prev-en {
      right: 0;
      left: auto;
    }
  }
  @media (max-width: 767px) {
    #leaderBoardsSection {
      flex-wrap: wrap;
    }
    #leaderBoardsSection .course-swiper {
      width: 80%;
      padding-inline: 5px;
    }
    #leaderBoardsSection .course-swiper .nav-item button {
      white-space: nowrap;
      width: 140px !important;
      text-align: center;
      font-size: 11px;
      color: var(--dark-purple);
      padding: 7px 2px !important;
    }
    #leaderBoardsSection .leaderboards-data {
      margin-top: 30px;
      flex-direction: column;
    }
    #leaderBoardsSection .leaderboards-data .leaderboards-data-item {
      padding-top: 0px;
      margin-bottom: 0px;
      height: 350px;
    }
    #leaderBoardsSection
      .leaderboards-data
      .leaderboards-data-item:first-child {
      margin-inline-end: 0;
      margin-top: 0;
    }
    #leaderBoardsSection .leaderboards-data .leaderboards-data-item:last-child {
      margin-inline-start: 0;
      margin-top: 0;
    }
    #leaderBoardsSection .leaderboards-data .leaderboards-data-item .item-img {
      width: 260px;
      height: 260px;
    }
    .leaderboard-container .btn-next,
    .leaderboard-container .btn-prev {
      top: 7.5px;
      width: 30px !important;
      height: 30px !important;
    }
  }
`;
